import { render, staticRenderFns } from "./ProviderCreate.vue?vue&type=template&id=29b4d26a&lang=pug&"
import script from "./ProviderCreate.vue?vue&type=script&lang=js&"
export * from "./ProviderCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProviderCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderCreate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VLayout,
})
